export default __webpack_public_path__ + "static/media/FlightOption2.94ed4a93.jpg";